<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Sol panel: login ekraniyla ayni marka paneli. -->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center justify-content-center p-5 login-brand-side"
      >
        <div class="brand-content text-center">
          <b-img
            fluid
            :src="sideImg"
            alt="Vişne Madencilik"
            class="brand-content__logo mb-3"
          />
          <div class="brand-content__title">Lojistik Yönetim Sistemi</div>
          <div class="brand-content__subtitle mb-3">Vişne Madencilik &middot; Öztüre Holding</div>
        </div>

        <div class="brand-side__footer">
          &copy; {{ new Date().getFullYear() }} Öztüre Holding
        </div>
      </b-col>

      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- 1) Baglanti dogrulanirken -->
          <div v-if="checking" class="text-center">
            <b-spinner variant="primary" class="mb-2"></b-spinner>
            <b-card-text class="text-muted">Bağlantı doğrulanıyor...</b-card-text>
          </div>

          <!-- 2) Baglanti gecersiz / suresi dolmus.
               Form hic gosterilmez: kullanici yeni parolayi yazip gonderdikten
               sonra "baglanti gecersiz" duymamali. -->
          <template v-else-if="!tokenValid">
            <b-card-title title-tag="h2" class="font-weight-bolder mb-25 login-title">
              Bağlantı geçersiz ⛔
            </b-card-title>
            <b-card-text class="mb-2 text-muted">{{ invalidMessage }}</b-card-text>
            <b-button variant="primary" block class="login-submit" :to="{ name:'forgot-password' }">
              Yeni sıfırlama bağlantısı iste
            </b-button>
            <div class="text-center mt-2">
              <b-link :to="{ name:'login' }"><small>Giriş ekranına dön</small></b-link>
            </div>
          </template>

          <!-- 3) Parola basariyla degistirildi -->
          <template v-else-if="done">
            <b-card-title title-tag="h2" class="font-weight-bolder mb-25 login-title">
              Parolanız güncellendi ✅
            </b-card-title>
            <b-card-text class="mb-2 text-muted">{{ doneMessage }}</b-card-text>
            <b-button variant="primary" block class="login-submit" :to="{ name:'login' }">
              Giriş yap
            </b-button>
          </template>

          <!-- 4) Yeni parola formu -->
          <template v-else>
            <b-card-title title-tag="h2" class="font-weight-bolder mb-25 login-title">
              Yeni parolanızı belirleyin 🔐
            </b-card-title>
            <b-card-text class="mb-2 text-muted">
              Parolanızı belirledikten sonra yeni parolanız ile giriş yapabilirsiniz.
            </b-card-text>

            <validation-observer ref="resetValidation">
              <b-form class="auth-login-form mt-2" @submit.prevent>

                <b-form-group label="Yeni Parola" label-for="reset-password">
                  <!-- vee-validate'in hazir "password" kurali sunucudakinden daha katidir
                       (ozel karakter de ister) ve ASCII disi harfleri tanimaz. Kural bu
                       yuzden sunucudaki PasswordPolicy'nin ekran karsiligindan gelir;
                       hata metnini de o uretir, boylece iki taraf ayni seyi soyler. -->
                  <validation-provider
                    #default="{ errors }"
                    name="Parola"
                    vid="password"
                    rules="password-policy"
                  >
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="LockIcon"/>
                      </b-input-group-prepend>
                      <b-form-input
                        id="reset-password"
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false : null"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="showPassword ? 'EyeOffIcon' : 'EyeIcon'"
                          @click="showPassword = !showPassword"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                    <small v-else class="password-rule-hint">
                      En az 8 karakter; en az bir büyük harf, bir küçük harf ve bir rakam.
                    </small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="Yeni Parola (Tekrar)" label-for="reset-password-repeat">
                  <validation-provider
                    #default="{ errors }"
                    name="Parola Tekrarı"
                    rules="required|confirmed:password"
                  >
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="LockIcon"/>
                      </b-input-group-prepend>
                      <b-form-input
                        id="reset-password-repeat"
                        v-model="rePassword"
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false : null"
                        placeholder="············"
                        @keyup.enter="submit"
                      />
                    </b-input-group>
                    <small v-if="errors.length" class="text-danger">Parolalar eşleşmiyor.</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  type="submit"
                  variant="primary"
                  class="d-flex align-items-center justify-content-center login-submit"
                  block
                  :disabled="loading"
                  @click="submit"
                >
                  <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                  Parolayı Güncelle
                  <feather-icon v-if="!loading" icon="CheckIcon" size="14" class="ml-50"/>
                </b-button>
              </b-form>
            </validation-observer>
          </template>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend,
  BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner,
} from 'bootstrap-vue'
import { extend } from 'vee-validate'
import { required, confirmed } from '@validations'
import { AuthApi } from '@/api/auth'
import { validatePassword } from '@/utilities/auth/password-policy'

// Sunucudaki PasswordPolicy'nin ekran karsiligi vee-validate kurali olarak kaydedilir.
// Kural, sunucunun donecegi hata metninin AYNISINI uretir: kullanici formu gondermeden
// once de gonderdikten sonra da ayni cumleyi gorur.
extend('password-policy', {
  validate: value => {
    const error = validatePassword(value)
    return error === null ? true : error
  },
  // vee-validate, ozel kurallari BOS degerlerde calistirmaz; bu bayrak olmadan
  // bos parola alani dogrulamadan gecer ve form sunucuya bos parola gonderirdi.
  computesRequired: true,
})

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      token: this.$route.params?.token || null,
      checking: true,
      tokenValid: false,
      invalidMessage: 'Parola sıfırlama bağlantısı geçersiz veya süresi dolmuş. Lütfen yeni bir sıfırlama talebi oluşturunuz.',
      password: '',
      rePassword: '',
      showPassword: false,
      loading: false,
      done: false,
      doneMessage: '',
      sideImg: require('@/assets/images/logo/ozturelogo.png'),
      required,
      confirmed,
    }
  },
  mounted() {
    this.validateToken()
  },
  methods: {
    validateToken() {
      if (!this.token) {
        this.checking = false
        this.tokenValid = false
        return
      }
      AuthApi.ValidateResetToken(this.token)
        .then(res => {
          this.checking = false
          this.tokenValid = !!res?.data?.Success
          if (!this.tokenValid && res?.data?.Message) this.invalidMessage = res.data.Message
        })
        .catch(() => {
          this.checking = false
          this.tokenValid = false
        })
    },
    submit() {
      this.$refs.resetValidation.validate().then(success => {
        if (!success) return
        this.loading = true
        AuthApi.ResetPassword({
          Token: this.token,
          Password: this.password,
          RePassword: this.rePassword,
        })
          .then(res => {
            this.loading = false
            if (res?.data?.Success) {
              this.done = true
              this.doneMessage = res.data.Message
              // Parola bellekte gereksiz yere durmasin.
              this.password = ''
              this.rePassword = ''
              setTimeout(() => { this.$router.push({ name: 'login' }) }, 4000)
            } else {
              this.$result(res)
            }
          })
          .catch(err => {
            this.loading = false
            this.$result(null, err)
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import '@/assets/scss/auth-brand.scss';
</style>
